import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
export class VehicleDetailsTabfleetManagerCommentsComponent extends ABaseComponent {
    constructor(logger, ui, dss, dialog) {
        super(logger);
        this.logger = logger;
        this.ui = ui;
        this.dss = dss;
        this.dialog = dialog;
    }
    set vehicleService(v) {
        this._vehicleService = v;
        this.changeHandle();
    }
    get vehicleService() {
        return this._vehicleService;
    }
    changeHandle() { }
    onCommentInserting(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                event.data.id = event.data.__KEY__;
                event.data.createdAt = new Date();
                event.data.updatedAt = new Date();
                let { fleetManagerComments } = this.vehicleService;
                fleetManagerComments = [Object.assign({}, event.data, { __KEY__: undefined }), ...this.vehicleService.fleetManagerComments];
                this.vehicleService.fleetManagerComments = fleetManagerComments; // Update the local state with predicted data
                // Call the API to add the new fleetManagerComments
                const updatedVehicleService = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
                    .toPromise();
                // Update the local state with the response
                this.vehicleService.fleetManagerComments = updatedVehicleService.fleetManagerComments;
            }
            catch (error) {
                notify('Error inserting comment', 'error', 3000);
                console.error('Error inserting comment:', error);
                event.cancel = true;
            }
        });
    }
    onCommentUpdating(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { fleetManagerComments } = this.vehicleService;
                const index = fleetManagerComments.findIndex((inv) => inv.id === event.key.id);
                if (index !== -1) {
                    fleetManagerComments[index] = Object.assign({}, fleetManagerComments[index], event.newData, { updatedAt: new Date() });
                    const { fleetManagerComments: updated } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
                        .toPromise();
                    this.vehicleService.fleetManagerComments = updated;
                }
            }
            catch (error) {
                notify('Error updating comment', 'error', 3000);
                console.error('Error updating comment:', error);
                event.cancel = true;
            }
        });
    }
    onCommentRemoving(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { fleetManagerComments } = this.vehicleService;
            const index = fleetManagerComments.findIndex((inv) => inv.id === event.key.id);
            if (index !== -1) {
                fleetManagerComments.splice(index, 1);
                const { fleetManagerComments: updated } = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { fleetManagerComments })
                    .toPromise();
                this.vehicleService.fleetManagerComments = updated;
            }
        });
    }
}
